'use client';

import { Icons } from '@/components/Shares/Icons';
import modalStyles from '@/components/Shares/Modal.module.css';
import { useChat } from '@/providers/ChatProvider';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Center, Flex, List, Modal, Paper, Text } from '@mantine/core';
import { IconPointFilled } from '@tabler/icons-react';
import classes from './Aside.module.css';
import { ChatRuleItem } from './ChatRuleItem';
export const ChatRuleModal: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  const {
    setActiveExtension
  } = useChat();
  const {
    i18n
  } = useLingui();
  const handleClose = () => {
    setOpenModal(null);
    setActiveExtension(null);
  };
  return <Modal opened={openModal === MODAL.CHAT_RULES} onClose={handleClose} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.95)'
  }} size="100%" classNames={modalStyles}>
      <Flex justify="center" w="100%">
        <Flex direction="column" gap={24} mb={24} align="center" h="100%" miw={{
        base: '100%',
        sm: 648,
        lg: 690
      }}>
          <Text c="var(--text-white)" fz={{
          base: 20,
          sm: 24,
          lg: 20
        }} className={gunterzBold.className}>
            {i18n._('Chat rules')}
          </Text>

          <Paper w="100%" p={{
          base: 10,
          sm: 20,
          lg: 40
        }} radius={5} bg="#22262A">
            <List icon={<Center>
                  <IconPointFilled size={20} color="var(--text-prime)" />
                </Center>} classNames={{
            item: classes.item
          }}>
              <ChatRuleItem text={i18n._('No harassment, insults, or offensive language; keep it friendly!')} />
              <ChatRuleItem text={i18n._('Don’t ask for loans, tips, or coins.')} />
              <ChatRuleItem text={i18n._('No spam or excessive capital letters.')} />
              <ChatRuleItem text={i18n._('No ads, trading, or selling services.')} />
              <ChatRuleItem text={i18n._('Suspicious behavior won’t be tolerated.')} />
              <ChatRuleItem text={i18n._('Submit original links; no URL shorteners.')} />
              <ChatRuleItem text={i18n._('Use the designated language for each chat channel.')} />
              <ChatRuleItem text={i18n._('Don’t share personal information.')} />
              <ChatRuleItem text={i18n._('Using multiple accounts in chat is prohibited.')} />
              <ChatRuleItem text={i18n._('No racism, sexism, or hate speech.')} />
              <ChatRuleItem text={i18n._('Keep the chat game-focused; no politics or religion.')} />
              <ChatRuleItem text={i18n._(`Don't insinuate bad intentions about Prime Roll.`)} />
              <ChatRuleItem text={i18n._('Don’t ask to become a staff member.')} />
            </List>
          </Paper>
        </Flex>
      </Flex>
    </Modal>;
};